import React from 'react'
import "../feedback/Feedback.css"
import { Col, Container, Row } from 'react-bootstrap'
const Feedback = () => {
  return (
    <>
     <section id="feedback">
        <Container>
             <h1>Some Customer Feedback</h1>
            <Row className='pt-5' style={{rowGap:'20px'}}>
                <Col lg={6}>
                    <div class="feedback_main">
                        <ul class="icson">
                            <li><i class="fa-solid fa-star"></i></li>
                            <li><i class="fa-solid fa-star"></i></li>
                            <li><i class="fa-solid fa-star"></i></li>
                            <li><i class="fa-solid fa-star"></i></li>
                            <li><i class="fa-solid fa-star"></i></li>
                        </ul>
                        <p>Nulla quis lorem ut libero malesuada feugiat. Nulla quis lorem ut libero malesuada feugiat. Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                        <div class="feedback_inner">
                            <div class="feedback_inner_img">
                                <div class="feedback_img">
                                 <img src="imeges/desktop 9/Feedback-icon.svg" alt=""/>
                                </div>
                                <div class="feedback_text">
                                    <h4>Awlad Hossain</h4>
                                    <p>UI Designer</p>
                                </div>
                            </div>
                            <div class="feedback_icon text-end">
                                <i class="fa-solid fa-quote-right"></i>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col lg={6}>
                    <div class="feedback_main">
                        <ul class="icson">
                            <li><i class="fa-solid fa-star"></i></li>
                            <li><i class="fa-solid fa-star"></i></li>
                            <li><i class="fa-solid fa-star"></i></li>
                            <li><i class="fa-solid fa-star"></i></li>
                            <li><i class="fa-solid fa-star"></i></li>
                        </ul>
                        <p>Nulla quis lorem ut libero malesuada feugiat. Nulla quis lorem ut libero malesuada feugiat. Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                        <div class="feedback_inner">
                        <div class="feedback_inner_img">
                            <div class="feedback_img">
                            <img src="imeges/desktop 9/Feedback-icon.svg" alt=""/>
                            </div>
                            <div class="feedback_text">
                            <h4>Awlad Hossain</h4>
                            <p>UI Designer</p>
                            </div>
                        </div>
                        <div class="feedback_icon text-end">
                            <i class="fa-solid fa-quote-right"></i>
                        </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
     </section>
    </>
  )
}

export default Feedback